import React, { useEffect, useState } from 'react'
import { closedTicketsAmount } from '../../../services/report.service';
import { useProject } from '../../../context/ProjectContext';
import { APIResponseModel } from '../../../models/api-call';
import SimpleBarChart from '../../common/Charts/SimpleBarChart';
import { SimpleBarChartDataItem } from '../../../models/charts';
import { LoadingSpinner } from '../../common/Icons';
import { fillRangeValues, getYTicks, setBarLabel } from './common';
import './widget-styles.css'
import { useNotification } from '../../../context/NotificationContext';

interface ClosedTicketAmountChartWidgetProps {
  title?: string
  filters: { from: string, to: string, [key: string]: any }
  height?: number
  reload?: boolean
}

const ClosedTicketAmountChartWidget: React.FC<ClosedTicketAmountChartWidgetProps> = ({
  title = '',
  filters,
  reload = false,
  height = 400
}) => {

  const { selectedProject } = useProject()
  const { showNotification } = useNotification()

  const [loading, setLoading] = useState<boolean>(true)
  const [dataChart, setDataChart] = useState<SimpleBarChartDataItem[]>([])

  const makeDataChart = (data: SimpleBarChartDataItem[]) => {
    setDataChart(fillRangeValues(filters.from, filters.to, data))
  }

  const initComponent = () => {
    if (filters.from && filters.to) {
      setLoading(true)
      Promise.all([closedTicketsAmount(selectedProject, filters)
      ]).then(function (result: APIResponseModel[]) {
        makeDataChart(result[0].data)
        setTimeout(() => setLoading(false), 1000)
      }).catch((error) => {
        setLoading(false)
        showNotification(<span>{error.response.data}</span>, 'error')
      });
    }
  }

  useEffect(initComponent, [reload])

  return (
    <React.Fragment>
      <div className='widget-section' style={{ flex: 1, height: height }}>
        {title && (<p className='title-widget'>{title}</p>)}
        {loading ? <div className='loading-widget'><LoadingSpinner /></div> : (
          <SimpleBarChart
            data={dataChart}
            yTicks={getYTicks(dataChart.map(item => item.y))}
            renderBarLabel={setBarLabel}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default ClosedTicketAmountChartWidget;

